import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import Handsontable from 'handsontable';
import {environment} from '../../environments/environment';
import {ReportDataService} from '../report-data.service';

@Component({
  selector: 'app-mapped-tables',
  templateUrl: './mapped-tables.component.html',
  styleUrls: ['./mapped-tables.component.scss']
})
export class MappedTablesComponent implements OnInit {

  environment: any;
  templateURL: string;

  constructor(private router: Router, private reportService: ReportDataService) { }

  ngOnInit() {
    this.environment = environment;
    this.router.navigate([ {outlets: { generatedTables: [this.environment.END_ITEMS] }}]);
    this.reportService.setSelectedWorksheet(this.environment.END_ITEMS);
    this.reportService.getTemplate().subscribe(value => this.templateURL = value);
  }

  updateHeaders() {
  }

  changeTab(target: String) {
    this.reportService.setSelectedWorksheet(target);
    this.router.navigate([ {outlets: { generatedTables: [target] }}]);
  }

}



// WEBPACK FOOTER //
// ./src/app/mapped-tables/mapped-tables.component.ts